// Formatação de datas padronizada PT-BR para todo o sistema.

// "2025-04-09T13:12:27" ou "2025-04-09" ou Date → "09/04/2025"
export function formatDateBR(value) {
  if (!value) return "—";
  // ISO string (yyyy-mm-dd...) — usa os 10 primeiros chars sem fuso
  if (typeof value === "string") {
    const d = value.substring(0, 10).split("-");
    if (d.length === 3 && d[0].length === 4) return `${d[2]}/${d[1]}/${d[0]}`;
  }
  const dt = value instanceof Date ? value : new Date(value);
  if (isNaN(dt.getTime())) return typeof value === "string" ? value : "—";
  const dd = String(dt.getDate()).padStart(2, "0");
  const mm = String(dt.getMonth() + 1).padStart(2, "0");
  return `${dd}/${mm}/${dt.getFullYear()}`;
}

// → "09/04/2025 às 13:12"
export function formatDateTimeBR(value) {
  if (!value) return "—";
  const dt = value instanceof Date ? value : new Date(value);
  if (isNaN(dt.getTime())) return formatDateBR(value);
  const hh = String(dt.getHours()).padStart(2, "0");
  const mi = String(dt.getMinutes()).padStart(2, "0");
  return `${formatDateBR(dt)} às ${hh}:${mi}`;
}

// Datas de prazo são civis e seguem o escritório em São Paulo, não o fuso do
// navegador. O formato ISO de data permanece intacto para evitar deslocamento.
export function todayCivilSP() {
  const parts = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/Sao_Paulo", year: "numeric", month: "2-digit", day: "2-digit",
  }).formatToParts(new Date());
  const value = Object.fromEntries(parts.map((part) => [part.type, part.value]));
  return `${value.year}-${value.month}-${value.day}`;
}

export function formatCivilDateBR(value) {
  return formatDateBR(typeof value === "string" ? value.slice(0, 10) : value);
}
